import { Modal, Panel, Table } from 'react-bootstrap';
import styled from 'styled-components';

export const TableWrapper = styled(Table)`
    width: 100%;
    margin-bottom: 0px;

    & > thead > tr > th,
    & > thead > tr > td {
        text-align: center;
        // border: 1px solid blue;
    }

    & > tbody > tr > td {
        text-align: center;
        vertical-align: middle;
        padding-top: 2px;
        padding-bottom: 2px;
    }

    & > tbody > tr > td > label,
    & > tbody > tr > td > span.label {
        font-size: 100%;
    }

    .text-xs {
        font-size: 75%;
    }

    .label, .label.no-value {
        min-width: 30px;
        display: inline-block;
        padding: 5px 3px;
        margin: 1px 2px;
    }

    .label.no-value {
        min-width: 30px;
        display: inline-block;
        padding: 5px 3px;
        margin: 1px 2px;
        background-color: transparent;
        color: #333;
    }
`;

export const MedicalDemographicPreferencesTableWrapper = styled(Table)`
    width: 100%;

    & > tbody > tr > td:nth-child(1) {
        text-align: center;
    }

    & > tbody > tr > td > span.label,
    & > tbody > tr > td > label {
        margin-bottom: 0px;
        font-size: 100%;
    }

    & > tbody > tr > td {
        vertical-align: middle;
    }
`;

export const WellTopWrapper = styled.div`
    background-color: #f5f5f5;
    padding: 5px;
    min-height: 70px;
    display: flex;
    align-items: center;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border-width: 1px 1px 0px 1px;
    border-style: solid;
    border-color: #e3e3e3;
`;

export const WellBottomWrapper = styled.div`
    background-color: #f5f5f5;
    padding: 10px;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    border-width: 0px 1px 1px 1px;
    border-style: solid;
    border-color: #e3e3e3;
`;

export const ContentWrapper = styled.div`
    width: 100%;
    // border-left: 1px solid #ddd;
    // border-right: 1px solid #ddd;
    // border-bottom: 1px solid #ddd;
    min-height: 65vh;
    padding-top: 0px;
    padding-left: 5px;
    padding-right: 5px;
    margin-bottom: 5px;
    background-color: #FFF;
`;

export const PanelWrapper = styled(Panel)`
    & > .panel-heading > .panel-title > .heading {
        font-size: ${p => p.small ? '16px' : '18px'}
    }

    & > .panel-heading > .panel-title {
        margin-right: 5px;
    }
`;

interface IHlaTableWrapperProps {
    small: boolean
}

export const HlaTableWrapper = styled.table<IHlaTableWrapperProps>`
    min-width: 400px;
    margin-bottom: 0px;
    //max-width: 500px;

    & > tbody > tr > td > .label {
        font-size: 100%;
    }

    & > thead > tr > th,
    & > tbody > tr > td {
        font-size: ${p => p.small ? '12px' : '14px'}
    }

    .hla-high-res {
        margin: 0px;
        max-width: 400px;
        word-wrap: break-word;
        white-space: pre-wrap;
        font-size: 12px;
    }
`;

export const TopButtonsWrapper = styled.div`
    margin-bottom: 20px;

    .btn-link {
        color: #333;
    }
`;

export const MatchDecisionBodyWrapper = styled(Modal.Body)`
    .form-group {
        margin-bottom: 5px;
    }
`;